module.exports = __webpack_public_path__ + "img/coach--heidiland.8250275d.png";